import * as React from 'react';
import { BaseThemeProvider, createGlobalStyle } from "../styled";
import { createTheme, reset } from "../themes";
export var LucidGlobalStyle = createGlobalStyle(function (_a) {
    var theme = _a.theme;
    return [
        reset,
        "\n    body {\n      font-size: " + theme.typography.content.fontSize + ";\n      font-weight: " + theme.fontWeights.regular + ";\n      font-family: " + theme.fontFamilies.default + ";\n      color: " + theme.colors.primary500 + ";\n      background: " + theme.colors.white + ";\n      box-sizing: border-box;\n      padding: 0;\n      margin: 0;\n    }\n    *, *::after, *::before {\n      box-sizing: inherit;\n    }\n  "
    ];
});
/**
 * This provider should be used by every Lucidium based application.
 * It provides default styles.
 */
export var LucidiumProvider = function (_a) {
    var children = _a.children, theme = _a.theme;
    return (React.createElement(BaseThemeProvider, { theme: createTheme(theme) },
        React.createElement(React.Fragment, null,
            React.createElement(LucidGlobalStyle, null),
            children)));
};
//# sourceMappingURL=index.js.map